module.exports = __webpack_public_path__ + "img/next-arrow.bb27e708.svg";